import React, { memo } from "react";

import Typography from "@mui/material/Typography";

import { CookTimeIcon, EggIcon, NonVegIcon, PrepTimeIcon, TagDotIcon, TimeDotIcon, VeganIcon, VegIcon } from "../iconRef/recipePageIcons";
import styles from './recipeCard.module.css';

const formatTime = (time: number): string => {
    const hr = Math.floor(time / 60);
    const min = time % 60;

    return time > 60
        ? `${hr}h ${min || ''}${min ? 'm' : ''}`
        : `${time} mins`;
};

export const PrepTime = memo(({ prepTime }: { prepTime: number }) => {

    if (prepTime <15) return null;

    const prepTimeText = formatTime(prepTime);

    return (
        <>
            <div className={styles.prep_time}>
                <div className={styles.prep_time_icon}>
                    <PrepTimeIcon />
                </div>
                <div className={styles.prep_time_text}>
                    <Typography variant="tagsAndTimeAndServingSize">
                        {prepTimeText}
                    </Typography>
                </div>
            </div>
            <div className={styles.time_dot_icon}>
                <TimeDotIcon />
            </div>
        </>
    );
});

export const CookTime = memo(({ cookTime }: { cookTime: number }) => {
    if (cookTime <= 0) return null;
    const cookTimeText = formatTime(cookTime);

    return (
        <div className={styles.cook_time}>
            <div className={styles.cook_time_icon}>
                <CookTimeIcon />
            </div>
            <div className={styles.cook_time_text}>
                <Typography variant="tagsAndTimeAndServingSize">
                    {cookTimeText}
                </Typography>
            </div>
        </div>
    );
});

export const CategoryIcon = memo(({ category, recipeName }: { category: string, recipeName: string }) => {
    switch (category) {
        case 'Veg':
            return <VegIcon className={styles.icon_wrapper} key={`veg-${recipeName}`} />;
        case 'Vegan':
            return <VeganIcon className={styles.icon_wrapper} key={`vegan-${recipeName}`} />;
        case 'Egg':
            return <EggIcon className={styles.icon_wrapper} key={`egg-${recipeName}`} />;
        case 'Non-Veg':
            return <NonVegIcon className={styles.icon_wrapper} key={`non-veg-${recipeName}`} />;
        default:
            return null;
    }
});

export const Tags = ({ category, tags, recipeName }: { category: string, tags: string[], recipeName: string }) => (
    <div className={styles.tags_and_categories}>
        <div className={styles.category}>
            <CategoryIcon category={category} recipeName={recipeName} />
        </div>
        <div className={styles.tags}>
            {tags.map((tag, index) => (
                <React.Fragment key={`${tag}-${index}`}>
                    <Typography variant="tagsAndTimeAndServingSize">{tag}</Typography>
                    {index !== tags.length - 1 ? <TagDotIcon className={styles.tag_dot_icon} /> : null}
                </React.Fragment>
            ))}
        </div>
    </div>
);
